import * as React from 'react';
import { DragDropContext, Droppable, DropResult } from 'react-beautiful-dnd';

import { IEditForm } from '../types';
import { Button, Icons, Tooltip } from 'src/components';
import ItemGroup from './ItemGroup';
import GroupEntries from './GroupEntries';

const { useState } = React;

const EditForm: React.FC<IEditForm> = ({
  group,
  items,
  onSave,
  addGroup,
  removeGroup,
  moveGroup,
  moveItem,
  setGroupName,
  toggleGroupExpand,
  setAllGroupsExpand,
  closeRow,
}) => {
  const [isSubmitting, setSubmitting] = useState(false);

  const save = async (event: React.FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    await onSave();
    setSubmitting(false);
    closeRow();
  };

  const onDragEnd = (result: DropResult) => {
    const { source, destination, type } = result;
    if (!destination) {
      return;
    }
    if (type === 'group') {
      moveGroup(source.index, destination.index);
    }
    if (type === 'item') {
      moveItem(source, destination);
    }
  };

  return (
    <form className="pt-5 mx-px" onSubmit={save}>
      <DragDropContext onDragEnd={onDragEnd}>
        <div className="flex mb-4">
          <div className="flex-1 flex flex-col mr-3">
            <div className="flex items-center mb-3 px-4">
              <p className="flex-1 font-bold">Groups</p>
              <Tooltip className="ml-4" text={'Expand all'}>
                <button
                  type="button"
                  className="p-2"
                  onClick={setAllGroupsExpand.bind(null, true)}
                >
                  <Icons.CaretDown size={18} />
                </button>
              </Tooltip>
              <Tooltip className="ml-2" text={'Collapse all'}>
                <button
                  type="button"
                  className="p-2"
                  onClick={setAllGroupsExpand.bind(null, false)}
                >
                  <Icons.CaretDown size={18} className={'flip-y'} />
                </button>
              </Tooltip>
            </div>
            <Droppable droppableId="groups" type="group">
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  className="flex-1 max-h-halfscreen overflow-y-scroll pb-6"
                >
                  {group.itemGroups.map((itemGroup, index) => (
                    <ItemGroup
                      key={`dragGroup-${itemGroup.id}`}
                      index={index}
                      itemGroup={itemGroup}
                      removeGroup={removeGroup(itemGroup.id)}
                      setGroupName={setGroupName(itemGroup.id)}
                      toggleGroupExpand={toggleGroupExpand(itemGroup.id)}
                    />
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
            <Button size="small" className="mt-2 ml-4 mr-6" onClick={addGroup}>
              Add Group
            </Button>
          </div>
          <div className="flex-1 flex flex-col">
            <p className="mx-3 mb-3 font-bold">Items</p>
            <div className="flex-1 max-h-halfscreen overflow-y-scroll px-3">
              <GroupEntries groupId="items" items={items} />
            </div>
          </div>
        </div>

        <div className="flex items-center pl-4 pr-6 pt-4 pb-5">
          <div className="flex-1" />
          <Button
            type="submit"
            background="grey"
            loading={isSubmitting}
            loadingLabel="Saving"
          >
            Save
          </Button>
        </div>
      </DragDropContext>{' '}
    </form>
  );
};

export default EditForm;



// WEBPACK FOOTER //
// ./src/views/Admin/ItemGroups/components/EditForm.tsx